<style scoped>
.navbar-wrap {
  z-index: 999;
  position: fixed;
  top: 0;
  width: 100%;
  height: 90px;
  /* background-image: url('../../../assets/image/navbar/navbar_backimage@2x.png');*/
  background: #1c96d4;
  min-width: 1366px;
}
.navbar-operate-wrap {
  background-image: none;
  background-color: #fff;
}
.navbar-bottom {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1181px;
  margin: 0 auto;
}
.logo {
  /*height: 52px;
        width: 184px;*/
  /* margin: 12px 124px 14px 0; */
  margin-right: 36px;
}
.navbar-items {
  /* position: relative;
        left:-150px; */
}
.navbar-item {
  color: #fff;
  margin-left: 20px;
  margin-right: 20px;
  font-size: 20px;
  cursor: pointer;
  display: inline-block;
  height: 90px;
  line-height: 90px;
  box-sizing: border-box;
}
.navbar-item:hover {
  /*color: #6BFFFD;*/
  border-bottom: 2px solid #fff;
}
.navbar-item-click {
  border-bottom: 2px solid #fff;
}
.navbar-item-cur {
  border-bottom: 2px solid rgb(28, 150, 212);
}

.navbar-item-operate {
  color: #333333;
}
.navbar-item-operate:hover {
  color: rgb(28, 150, 212);
}
</style>

<template>
  <div :class="{ 'navbar-wrap': true, 'navbar-operate-wrap': operateStyle }">
    <div class="navbar-bottom">
      <img :src="operateStyle ? logoWhiteUrl : logoUrl" alt class="logo" />
      <div class="navbar-items">
        <span
          v-for="(item, index) in navItem"
          :key="index"
          :class="{ 'navbar-item': true, 'navbar-item-operate': operateStyle,'navbar-item-cur':(operateStyle&&currentIndex == index), 'navbar-item-click': currentIndex == index}"
          @click="navbarItemClicked(item, index)"
        >{{ item }}</span>
        <!-- <menu-picker v-if="operateStyle" :slots="menuPickerSlots" :menu-show="menuPickerShow" @mouseenter.native="pickerShow(2)"
                @mouseleave.native="pickerShow(2)" @change="menuPickerClicked" operateStyle></menu-picker>
                <menu-picker v-else :slots="menuPickerSlots" :menu-show="menuPickerShow" @mouseenter.native="pickerShow(2)"
        @mouseleave.native="pickerShow(2)" @change="menuPickerClicked"></menu-picker>-->
      </div>
    </div>
  </div>
</template>

<script>
import MenuPicker from "./MenuPicker";
import communicate from "../../../communicate";

export default {
  name: "navbar",
  components: { MenuPicker },
  props: {
    operateStyle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logoWhiteUrl: require("../../../assets/image/navbar/logo.png"),
      logoUrl: require("../../../assets/image/navbar/meyoung-home_headerlogo.png"),
      navItem: [
        "首页",
        "米阳智链",
        "米阳供应链",
        "战略合作",
        "新闻/动态",
        "成功见证",
        "走进米阳",
        "联系我们"
      ],
      // menuPickerSlots: ['米阳智链', '执法大师', '米阳干线运输'],
      menuPickerShow: false,
      currentIndex: 0
    };
  },
  methods: {
    navbarItemClicked(item, index) {
      this.currentIndex = index;
      sessionStorage.setItem("nav_item_index", index);
      this.$emit("change", item, index);
    },
    menuPickerClicked(item, index) {
      this.currentIndex = 2;
      sessionStorage.setItem("nav_item_index", "menu" + index);
      this.$emit("menuChange", item, index);
    },
    pickerShow(index) {
      // if (index == 2) {
      //     this.menuPickerShow = !this.menuPickerShow
      // }
    }
  },
  created() {
    let currentIndex = sessionStorage.getItem("nav_item_index");
    if (currentIndex) {
      if (currentIndex.indexOf("menu") > -1) {
        this.currentIndex = 2;
      } else {
        this.currentIndex = currentIndex;
      }
    } else {
      this.currentIndex = 0;
    }
  },
  mounted() {
    let _this = this;
    communicate.$on("navItemChange", function(index) {
      //底部和navbar对应
      if (index == 0) {
        _this.currentIndex = 6;
      } else if (index == 1) {
        _this.currentIndex = 3;
      } else if (index == 2) {
        _this.currentIndex = 4;
      }
      else if(index == 3){
          _this.currentIndex = 8
      }
      else if (index == 4) {
        _this.currentIndex = 7;
      } else if (index == 5) {
        _this.currentIndex = 1;
      } else {
        _this.currentIndex = 2;
      }
      sessionStorage.setItem("nav_item_index", _this.currentIndex);
      if (index != 6) {
        _this.$emit("change", "", _this.currentIndex);
      }
    });

    communicate.$on('initNavItemIndex', function(index) {
        _this.currentIndex = index
        sessionStorage.setItem('nav_item_index', _this.currentIndex)
        _this.$emit('change', '', _this.currentIndex)
    })

    communicate.$on('proChange', function(index) {
        if (index == 0) {
            _this.navbarItemClicked('', 1)
        } else if (index == 1) {
            _this.menuPickerClicked('', 2)
        } else {
            _this.menuPickerClicked('', 1)
        }
    })
  }
};
</script>




// WEBPACK FOOTER //
// src/components/page/common/NavBar.vue